import React from "react";
import Dialer from "./components/Dialer";

export default function App() {
  return <Dialer />;
}
